import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import ScheduleCard from './schedule-card';
import { HotelSaleFormType } from '../form-type';
import { addNewHotelSaleItem } from '../hooks/use-get-default-values';

export default function HotelSection() {
  const { t } = useTranslation();
  const { control } = useFormContext<HotelSaleFormType>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'hotelSales',
    keyName: 'customId',
  });
  const onAdd = () => append(addNewHotelSaleItem());

  const onRemove = React.useCallback((index) => remove(index), [remove]);

  const { editable } = useFormState();

  return (
    <div>
      {fields.map((field, idx) => (
        <React.Fragment key={field.customId}>
          <ScheduleCard
            parentIndex={idx}
            onRemove={() => onRemove(idx)}
            fieldLength={fields.length}
          />
          <SeparatorVertical $margin={20}>
            <div style={{ height: 1, width: 4 }} />
          </SeparatorVertical>
        </React.Fragment>
      ))}
      {editable && (
        <Button buttonType="secondary" onClick={onAdd}>
          {t('common:add_extra', { extra: t('ticketSales:schedule') })}
        </Button>
      )}
    </div>
  );
}
